import React, { useState } from 'react';
import Icon from '../../utils/icons';
import './Skills.css';

const proficiencyConfig: Record<string, { label: string; color: string; bg: string; border: string }> = {
    'Proficient': {
        label:  'Proficient',
        color:  'var(--primary-color)',
        bg:     'rgba(8,145,178,0.08)',
        border: 'rgba(8,145,178,0.25)',
    },
    'Familiar': {
        label:  'Familiar',
        color:  '#7c3aed',
        bg:     'rgba(124,58,237,0.07)',
        border: 'rgba(124,58,237,0.22)',
    },
};

interface Props {
    skills: Record<string, any>;
}

const Skills: React.FC<Props> = ({ skills }) => {
    const [expanded, setExpanded] = useState<string | null>(null);
    const categories = Object.keys(skills);

    return (
        <div className="skills-wrapper">
            {categories.map((category, idx) => {
                const cat   = skills[category];
                const levels = Object.fromEntries(
                    Object.entries(cat).filter(([, val]) => Array.isArray(val))
                ) as Record<string, string[]>;
                const isOpen     = expanded === category;
                const totalSkills = Object.values(levels).reduce((acc, arr) => acc + arr.length, 0);

                return (
                    <div key={category} className={`skill-category-card ${isOpen ? 'open' : ''}`}>
                        <button
                            className="skill-category-header"
                            onClick={() => setExpanded(isOpen ? null : category)}
                            aria-expanded={isOpen}
                            aria-controls={`skill-panel-${idx}`}
                        >
                            <div className="skill-category-left">
                                <span className="skill-icon" aria-hidden="true">{cat.icon ?? <Icon name="wrench" size={16} />}</span>
                                <span className="skill-category-name">{category}</span>
                            </div>
                            <div className="skill-category-right">
                                <span className="skill-count" aria-hidden="true">{totalSkills} skills</span>
                                <span className={`chevron ${isOpen ? 'up' : 'down'}`} aria-hidden="true">›</span>
                            </div>
                        </button>

                        {isOpen && (
                            <div
                                id={`skill-panel-${idx}`}
                                className="skill-levels"
                                role="region"
                                aria-label={`${category} skills`}
                            >
                                {Object.keys(levels).map((level) => {
                                    const config = proficiencyConfig[level] || proficiencyConfig['Familiar'];
                                    return (
                                        <div key={level} className="skill-level-group">
                                            <span className="level-label" style={{ color: config.color }}>
                                                {level}
                                            </span>
                                            <div className="skill-tags">
                                                {levels[level].map((skill) => (
                                                    <span
                                                        key={skill}
                                                        className="skill-tag"
                                                        style={{
                                                            background:  config.bg,
                                                            borderColor: config.border,
                                                            color:       config.color,
                                                        }}
                                                    >
                                                        {skill}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(Skills);
